import React, { Component, ErrorInfo, ReactNode } from "react";

interface IProps {
    children: ReactNode;
    FallbackComponent?: () => {};
}

interface IState {
    hasError: boolean;
}

class ErrorBoundary extends Component<IProps, IState> {

    public static getDerivedStateFromError(_: Error): IState {
        // Update state so the next render will show the fallback UI.
        return { hasError: true};
    }
    public state: IState = {
        hasError: false
    };

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            if (this.props.FallbackComponent) {
                return this.props.FallbackComponent();
            }
            return (
                <h6>Sorry.. there was an error, please contact us
                    <a aria-label="user sends error report through email" href={
                        "mailto:dl.rsch.global.html.rendition@imcnam.ssmb.com?subject=Defect on Research doc &" +
                        "body=page url: " + window.location.href + "%0D%0A" +
                        "doc id: " + window.HTML_RENDITION.initialData.doc_id + "%0D%0A" +
                        "product type: " + window.HTML_RENDITION.initialData.productType + "%0D%0A"
                    }>&nbsp;here</a>
                </h6>);
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
